var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseSolidBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8589 24C10.6392 24 10.4195 23.916 10.2516 23.7485C9.91614 23.4134 9.91614 22.8692 10.2516 22.5338L22.5337 10.2516C22.8692 9.91613 23.4126 9.91613 23.7484 10.2516C24.0839 10.5867 24.0839 11.1308 23.7484 11.4663L11.4663 23.7485C11.2984 23.9164 11.0787 24 10.8589 24Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1411 24C22.9213 24 22.7016 23.916 22.5337 23.7485L10.2516 11.4663C9.91614 11.1312 9.91614 10.5871 10.2516 10.2516C10.5871 9.91613 11.1305 9.91613 11.4663 10.2516L23.7484 22.5338C24.0839 22.8689 24.0839 23.413 23.7484 23.7485C23.5805 23.9164 23.3608 24 23.1411 24Z",
    fill: "#424242"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSolidBackground);
export default __webpack_public_path__ + "static/media/close_solid_background.e8f156e95bacc094fabe669b7c0f0c5b.svg";
export { ForwardRef as ReactComponent };